module.exports = __webpack_public_path__ + "static/img/13.2f20cfc8.png";